import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ constraintId }) =>
    present(
      repository
        .getConstraint(constraintId)
        .then((constraint) => ({
          constraint,
          constraintId,
        }))
        .catch(() => Promise.reject({ constraintId })),
    );
}

export type { Interactor };

export { createInteractor };
